import { useState } from "react";
import { Star, Info } from "lucide-react";
import api from "../lib/api";

export default function LeadScoreBadge({ contact, size = "sm" }) {
  const [open, setOpen] = useState(false);
  const [live, setLive] = useState(null);
  const score = live?.score ?? contact.lead_score ?? 0;
  const rows = live?.breakdown || contact.lead_score_breakdown || [];
  const tone = score >= 75 ? "bg-emerald-50 text-emerald-700 border-emerald-200" : score >= 45 ? "bg-amber-50 text-amber-700 border-amber-200" : "bg-slate-50 text-slate-600 border-slate-200";
  const bar = score >= 75 ? "#059669" : score >= 45 ? "#d97706" : "#94a3b8";
  const show = async () => {
    setOpen(true);
    if (!live) { try { const { data } = await api.get(`/scoring/contacts/${contact.id}`); setLive(data); } catch { /* keep stored */ } }
  };
  return (
    <span className="relative inline-flex" onMouseEnter={show} onMouseLeave={() => setOpen(false)} onClick={(e) => { e.stopPropagation(); open ? setOpen(false) : show(); }} data-testid="lead-score-badge">
      <span className={`inline-flex items-center gap-1 rounded-full border font-semibold cursor-help ${size === "sm" ? "px-2.5 py-0.5 text-xs" : "px-3 py-1 text-sm"} ${tone}`}>
        <Star className={`${size === "sm" ? "w-3 h-3" : "w-3.5 h-3.5"} fill-current`} />{score}<Info className="w-3 h-3 opacity-60" />
      </span>
      {open && (
        <div className="absolute z-50 top-full left-0 mt-2 w-[340px] rounded-xl border border-slate-200 bg-white shadow-xl p-4 text-left cursor-default animate-fade-up" data-testid="lead-score-breakdown">
          <div className="flex items-baseline justify-between mb-1">
            <p className="text-xs font-bold uppercase tracking-wider text-gold-dark">Lead score</p>
            <p className="font-display text-2xl font-extrabold text-navy-800">{score}<span className="text-xs text-slate-400 font-normal"> / 100</span></p>
          </div>
          <p className="text-[11px] text-slate-500 mb-3">Auto-calculated from your Lead Scoring weights (Settings). Updates whenever the contact, a call, note or task changes.</p>
          <div className="space-y-2">
            {rows.length === 0 && <p className="text-xs text-slate-400">No breakdown yet — open the contact to calculate.</p>}
            {rows.map((r) => (
              <div key={r.key} data-testid={`score-row-${r.key}`}>
                <div className="flex justify-between text-xs">
                  <span className="text-navy-800 font-medium">{r.label}</span>
                  <span className={r.points === r.max ? "text-emerald-700 font-semibold" : r.points === 0 ? "text-slate-400" : "text-amber-700 font-semibold"}>{r.points > 0 ? "+" : ""}{r.points} / {r.max}</span>
                </div>
                <div className="h-1.5 rounded-full bg-slate-100 mt-1 overflow-hidden"><div className="h-full rounded-full transition-[width]" style={{ width: `${r.max ? (r.points / r.max) * 100 : 0}%`, background: bar }} /></div>
                <p className="text-[11px] text-slate-500 mt-0.5">{r.reason}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </span>
  );
}
